import React from 'react'
import { connect } from 'react-redux'
import { bool, func, string } from 'prop-types'
import Dehaze from 'react-icons/lib/md/dehaze'
import MdArrowBack from 'react-icons/lib/md/arrow-back'
import { toggleSidebar } from '../../../store/Actions/UiActions'
import './styles/MenuToggle.css'

const MenuToggle = ({ sidebarOpen, toggleSidebar, theme }) => (
  <button
    className="address-bar-menu"
    onClick={() => toggleSidebar(!sidebarOpen)}
    tabIndex="1"
  >
    {sidebarOpen ? <MdArrowBack color={theme} /> : <Dehaze color={theme} />}
  </button>
)

MenuToggle.propTypes = {
  sidebarOpen: bool.isRequired,
  toggleSidebar: func.isRequired,
  theme: string.isRequired,
}

const mapStateToProps = ({ ui, spi }) => ({
  sidebarOpen: ui.sidebarOpen,
  theme: spi.theme,
})

const mapDispatchToProps = dispatch => ({
  toggleSidebar: value => dispatch(toggleSidebar(value)),
})

export default connect(mapStateToProps, mapDispatchToProps)(MenuToggle)



// WEBPACK FOOTER //
// ./src/components/Elements/MenuToggle/index.jsx